import PropTypes from 'prop-types';

const H2 = ({ className, children }) => {
	return <h2 className={`h2 text-lg md:text-xl font-bold text-left select-none ${className}`}>
		{children}
	</h2>;
};

H2.propTypes = {
	children: PropTypes.any.isRequired,
	className: PropTypes.string
}

H2.defaultProps = {
	className: undefined
}

export default H2;
